// services/storage/api.js
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { downloadDataQueryFn, getUrlQueryFn } from "./util";
import { sliceNames } from "../util/constants";

export const storageApi = createApi({
  reducerPath: sliceNames.storage,
  baseQuery: fakeBaseQuery(),
  tagTypes: ["StorageItem"],
  endpoints: (builder) => ({
    downloadJsonData: builder.query({
      queryFn: downloadDataQueryFn
    }),
    getUrl: builder.query({
      queryFn: getUrlQueryFn
    })
  })
});

export const { useDownloadJsonDataQuery, useGetUrlQuery } =
  storageApi;
